import React, { useEffect, useState, useMemo } from "react";
import { useTable, useFilters, usePagination } from "react-table";
import { getTycAccept } from "services/tyc.service";

const PageDataTyC = () => {
  const [dataList, setDataList] = useState([]);

  useEffect(() => {
    const getTermsAndConditions = async () => {
      try {
        const response = await getTycAccept();
        setDataList(response.data); // Asigna los datos al estado
      } catch (error) {
        console.log(error);
      }
    };
    getTermsAndConditions();
  }, []);

  const data = useMemo(() => dataList, [dataList]);

  const columns = useMemo(
    () => [
      { Header: "Nombre", accessor: "nombre_completo" },
      { Header: "Contacto", accessor: "numero_contacto" },
      { Header: "Medio aceptación", accessor: "medio_aceptacion" },
      { Header: "Fecha aceptación", accessor: "fecha_aceptacion" },
      { Header: "Terminos y condiciones", accessor: "termino_texto" },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setFilter,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    state: { pageIndex },
  } = useTable(
    {
      columns,
      data,
    },
    useFilters,
    usePagination
  );

  return (
    <div>
      <input
        type="text"
        placeholder="Buscar..."
        onChange={(e) => setFilter("nombre_completo", e.target.value)}
        className="page-tyc-search-input" // Clase específica
      />
      <table {...getTableProps()} className="page-tyc-table">
        {" "}
        {/* Clase específica */}
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => (
                  <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="page-tyc-pagination">
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {"<<"}
        </button>
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          {"<"}
        </button>
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          {">"}
        </button>
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {">>"}
        </button>
        <span>
          Página {pageIndex + 1} de {pageOptions.length}
        </span>
      </div>
    </div>
  );
};

export default PageDataTyC;
